/**
 * Cryptography utilities for TaskFortress
 *
 * Note: For React Native environments, you need to install:
 * https://github.com/LinusU/react-native-get-random-values
 */

/**
 * Generates random bytes using the crypto.getRandomValues API
 * @param length Number of bytes to generate
 * @returns Uint8Array of random bytes
 */
export function getRandomBytes(length: number): Uint8Array {
  const bytes = new Uint8Array(length)
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    crypto.getRandomValues(bytes)
  } else {
    throw new Error(
      "crypto.getRandomValues is not available in this environment",
    )
  }
  return bytes
}

/**
 * Generates a master key in the format "ABCD-ABCD-ABCD-ABCD"
 * @returns A string containing the master key
 */
export function generateMasterKey(): string {
  // We'll use 16 bytes of randomness to generate a 16-character key
  const randomBytes = getRandomBytes(16)

  // Convert bytes to uppercase letters (A-Z)
  const keyChars = Array.from(randomBytes).map((byte) => {
    // Map byte to A-Z (ASCII 65-90)
    return String.fromCharCode(65 + (byte % 26))
  })

  // Format as "ABCD-ABCD-ABCD-ABCD"
  const segments = []
  for (let i = 0; i < keyChars.length; i += 4) {
    segments.push(keyChars.slice(i, i + 4).join(""))
  }

  return segments.join("-")
}
